<template>
  <div>
    <div class="modal-header">
      <span>Additional Information</span>
      <span class="modal-close" @click="$emit('close')" />
    </div>
    <div class="modal-body">
      <div class="modal-name">
        <h2>{{ text }}</h2>
      </div>
      <div style="text-align:left; padding: 0 20px;" v-html="content">
      </div>
    </div>
    <div class="mobile button-content">
      <button @click="saveInfo" type="button" class="w-btn us-btn-style_1">
        <span class="w-btn-label">Select this option</span>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'QuizHistoryModal',
  props: {
    text: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    content: {
      type: String,
    },
  },

  data() {
    return {
      additionalInfo: "",
    };
  },

  methods: {
    saveInfo() {
      this.$emit( 'saveHistory', { type: this.type, info: this.additionalInfo } );
      this.$emit( 'close' );
    }
  }
};
</script>

<style scoped>
.modal-body {
  height: calc(100vh - 300px);
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-header {
  color: #fff;
  background: var(--imc-primary-color);
  padding: 20px;
}

.modal-name {
  padding: 20px 20px 0;
}

.modal-close:before {
  float: right;
  cursor: pointer;
  margin-top: -0.5rem;
  content: '\f00d';
  font-family: 'fontawesome';
  font-weight: 400;
  color: #fff;
  font-size: 2rem;
  padding: 0.5rem;
}
</style>